<template>
  <div class="ChallengeType">
    <div id="form-div">
      <div class="row justify-content-center align-items-center px-3">
        <div class="col-md-10">
          {{ $t('wheelAnalysis.challengeType.prompt') }}
        </div>

        <div class="col-md-10">
          <MDBRadio
              style="text-align:left"
              :label="$t('wheelAnalysis.challengeType.options.housing')"
              name="challengeType"
              v-model="challengeType"
              value="Housing"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              style="text-align:left"
              :label="$t('wheelAnalysis.challengeType.options.transportation')"
              name="challengeType"
              v-model="challengeType"
              value="Transportation"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.parks')"
              name="challengeType"
              v-model="challengeType"
              value="Parks and Public Spaces"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.publicSafety')"
              name="challengeType"
              v-model="challengeType"
              value="Public Safety"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.publicHealth')"
              name="challengeType"
              v-model="challengeType"
              value="Public Health"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.education')"
              name="challengeType"
              v-model="challengeType"
              value="Education"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.food')"
              name="challengeType"
              v-model="challengeType"
              value="Food Safety and Food Security"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.water')"
              name="challengeType"
              v-model="challengeType"
              value="Water Quality"
              @change="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.waste')"
              name="challengeType"
              v-model="challengeType"
              value="Waste"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.disaster')"
              name="challengeType"
              v-model="challengeType"
              value="Disaster Preparedness"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.economic')"
              name="challengeType"
              v-model="challengeType"
              value="Economic Development and Zoning"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBRadio
              :label="$t('wheelAnalysis.challengeType.options.other')"
              name="challengeType"
              v-model="challengeType"
              value="Other"
              @blur="challengeStore.challengeTypeChanged"
              :disabled="!editMode"
          />

          <MDBInput
              v-if="challengeType === 'Other'"
              :label="$t('wheelAnalysis.challengeType.otherLabel')"
              v-model="challengeTypeOther"
              @blur="challengeStore.challengeTypeOtherChanged()"
              :disabled="!editMode"
          />
        </div>
      </div>

      <div class="sidebar-instructions p-4">
        {{ $t('wheelAnalysis.challengeType.guidanceNote') }}
      </div>
    </div>
  </div>

  <router-view />
</template>

<script src="./_ChallengeType.js" lang="js"></script>
<style src="./_ChallengeType.less" lang="less" scoped></style>
